if ($('#data-side-panel-create-task').length) {
    require('./tasks/create')
}
if ($('#data-side-panel-your-tasks').length) {
    require('./tasks/yours-side-panel')
}
